import { render, staticRenderFns } from "./BBList.vue?vue&type=template&id=469fc6d8"
import script from "./BBList.vue?vue&type=script&lang=js"
export * from "./BBList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports